// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-no-translate]{translate:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}@media screen and (min-width: 1440px){._aqAO{max-width:1200px !important}}@media screen and (min-width: 992px){._aqAO{max-width:1073px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"generalSection": "_aqAO"
};
module.exports = ___CSS_LOADER_EXPORT___;
